import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { useSelector } from "react-redux";
import { getAppUser } from "../../app/appSelectors";
import { Button, FormGroup } from "react-bootstrap";
import { UserStateInformationContentStyled, UserStateInformationStyled } from "./styled/UserStateInformationStyled";
import React, { useCallback, useMemo } from "react";
import { useZendeskContext } from "../Zendesk/zendeskContext";
import { PUBLIC_URL } from "../../config";
import { USER_STATE_NAMES } from "./UserState.t";

function UserStateInformation() {
    const { getLangPath } = useLangContext();
    const user = useSelector(getAppUser);
    const { openWebWidget } = useZendeskContext();

    const onClickHandler = useCallback((e) => {
        openWebWidget();
    }, [openWebWidget]);

    const image_name = useMemo(() => {
        return {
            [USER_STATE_NAMES.BLOCKED]: 'lock_sign',
            [USER_STATE_NAMES.CLOSE_ONLY]: 'alert_sign',
            [USER_STATE_NAMES.RESTRICTED]: 'stop_sign',
        }[user.state];
    }, [user]);

    return <UserStateInformationStyled>
        <UserStateInformationContentStyled>

            <img src={`${PUBLIC_URL}/assets/icons/${image_name}.svg`}
                 width={120}
                 height={120}
                 alt={''}/>
            <h3 className={'mt-4'}>{getLangPath(`user_state.${user.state}.title`)}</h3>
            {
                user.state_reason_code && <FormGroup className={'mt-4'}>
                    <span className="text-secondary">{getLangPath('user_state.reason')}&nbsp;</span>
                    <div className={'d-inline-block'}
                         dangerouslySetInnerHTML={{ __html: getLangPath(`user_state.reasons.${user.state_reason_code}.title`) }}/>
                </FormGroup>
            }
            <FormGroup className={'mt-4'}>
                {getLangPath(`user_state.reasons.${user.state_reason_code || 'customer_agreement_violation'}.description`)}
            </FormGroup>
        </UserStateInformationContentStyled>
        <div className={'mt-4'}>
            <div className={'f14 text-secondary mb-2'}>{getLangPath(`user_state.support.hint`)}</div>
            <Button variant={'secondary'} className={'w-100'}
                    onClick={onClickHandler}>{getLangPath('user_state.support.btn')}</Button>
        </div>
    </UserStateInformationStyled>;
}

export default UserStateInformation;
